// extracted by mini-css-extract-plugin
export var five = "nextgen-module--five--3926a";
export var four = "nextgen-module--four--cca7f";
export var next_gen_wrapper = "nextgen-module--next_gen_wrapper--8ca7b";
export var next_img = "nextgen-module--next_img--5971b";
export var nextgenBlock = "nextgen-module--nextgenBlock--e25cd";
export var one = "nextgen-module--one--16701";
export var three = "nextgen-module--three--0bad6";
export var two = "nextgen-module--two--39f76";